export default __webpack_public_path__ + "static/media/mens-shoes.bba44b5a.png";